import React from 'react';
import { Item } from 'semantic-ui-react';
import FavItem from '../collection-item/Item';

const ItemsContainer = (props) => {
  return (
    <Item.Group divided>
      {props.items?.map((item) => (
        <FavItem key={item.id} {...item} {...props} />
      ))}
    </Item.Group>
  );
};

export default ItemsContainer;
